import PaginationLinkButton from './PaginationLinkButton';

export default PaginationLinkButton;
